<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 sm6>
        <h1 id="product-list">PRODUCT LIST</h1>
      </v-flex>
      <v-flex xs12 sm6>
        <div class="text-xs-right">
          <v-layout class="form-control" align-content-end>
            <input
              type="text"
              v-model="searchText"
              :placeholder="$t('search')"
              class="form-control mb-0 p-0"
              style="line-height: 21px"
              @keyup.enter="onSearch"
            />
            <v-btn depressed color="primary" @click="onSearch">
              {{ $t('search') }}
            </v-btn>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
    <div class="mt-2 mb-2 text-xs-center">
      <v-pagination
        v-if="pagelength"
        v-model="page.page"
        :length="pagelength"
        @input="onClickPageinate"
      ></v-pagination>
    </div>
    <v-layout v-if="loading" row wrap justify-center class="mt-5">
      <v-progress-circular v-if="loading" :indeterminate="true" :height="2"></v-progress-circular>
    </v-layout>
    <v-layout v-if="products && products.length" row wrap class="mt-4">
      <v-flex xs12 md4 lg3 v-for="(item, index) in products" :key="`key-${index}`">
        <v-card class="mr-2 mb-4 pb-4">
          <v-img contain class="mb-1 radius-15" :src="item.image"></v-img>
          <v-card-text style="height: 80px"
            ><div class="primary--text">{{ item.name }}</div></v-card-text
          >
          <v-card-text class="py-1" style="color: gray; font-size: 14px"
            >Model : {{ item.model }}</v-card-text
          >
          <v-card-text class="py-1" style="color: gray; font-size: 14px"
            >Color : {{ item.color }}</v-card-text
          >
          <v-card-text class="py-1" style="color: gray; font-size: 14px"
            >Standard Price : {{ item.standardprice }}</v-card-text
          >
          <v-card-text class="py-1" style="color: gray; font-size: 14px"
            >Discount Price : {{ item.discountprice }}</v-card-text
          >
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-else-if="!loading" row wrap justify-center class="mt-5">
      Product not found
    </v-layout>
    <div class="mt-2 mb-2 text-xs-center">
      <v-pagination
        v-if="pagelength"
        v-model="page.page"
        :length="pagelength"
        @input="onClickPageinate"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import api from '@/api'
export default {
  data: function () {
    return {
      searchText: '',
      products: [],
      total: 0,
      imgSize: 220,
      page: {
        page: 1,
        quantity: 10
      },
      loading: false
    }
  },
  components: {},
  computed: {
    pagelength() {
      return Math.ceil(this.total / this.page.quantity)
    }
  },
  mounted() {
    this.fetchProductList()
  },
  methods: {
    onSearch() {
      this.page.page = 1
      this.fetchProductList()
    },
    async fetchProductList() {
      this.loading = true
      this.products = []
      this.total = 0
      this.products = await api.oabProductList({ page: this.page, search: this.searchText })
      this.loading = false
      if (this.products && this.products[0] && this.products[0].total) {
        this.total = this.products[0].total
      }
    },
    async onClickPageinate() {
      this.loading = true
      await this.fetchProductList()
      this.loading = false
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/template/reporter/product-list.vue